import store from '../store'
// ! to add another print call, to our api or another, please check the Store labelService app

export const labelService = async (orders = null) => {
  if (!orders || !orders.length || !Array.isArray(orders)) return false

  const okGenericLabel = await store.dispatch('labels/downloadLabels', orders)
  const okDHLLabel = await store.dispatch('labels/downloadDHLLabel', orders)

  return {
    okGenericLabel,
    okDHLLabel
  }
}



// WEBPACK FOOTER //
// ./src/services/labelService.js